module.exports = __webpack_public_path__ + "static/assets/852baaf645376ca8bc767865378c39ab.png";